import React, { useState } from 'react';
import LaddaButton, { ZOOM_OUT } from 'react-ladda';
import { Alert, ModalFooter, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModalComponent from './ModalComponent';
import TwoFaDigits from '../TwoFADigits/TwoFADigits';
import headerImg from '../../assets/img/other/second_factor_active.svg';
import { loginUser } from '../../auth/actions';
import { getTranslations } from '../../i18n/actions';
import Translate from '../../i18n/Translate/Translate';

const TwoFactorAuthModal = ({
  onToggle, isOpen, loading, loginUser, isError, errorType, getTranslations, options,
}) => {
  const [fullCode, setCodeState] = useState('');
  const setTwoFACode = (code) => {
    setCodeState(code);
  };

  const handleSendCode = () => (
    loginUser({
      email: options.email,
      password: options.password,
      tfaToken: fullCode,
    }, (error, data) => {
      !error && getTranslations(data.user.language);
    })
  );

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <ModalComponent
      title="Two Factor Authentication"
      isOpen={isOpen}
      onToggle={onToggle}
      name="LoginWithTFA"
      image={headerImg}
    >
      <form onSubmit={handleSubmit}>
        <p className="text-center mb-4 m-0 font-16 font-weight-light">
          Open your two authentication app and introduce the 6 digit code that appears for Securitize ID.
        </p>
        <TwoFaDigits
          callback={setTwoFACode}
        />
        <ModalFooter className="border-0 p-0 flex-column">
          <LaddaButton
            className="btn p-3 mb-3 text-white issuer-button-primary btn-block font-weight-bold"
            loading={loading}
            data-style={ZOOM_OUT}
            onClick={handleSendCode}
            disabled={fullCode.length < 6}
            type="submit"
          >
            <Translate translationKey="Texts.continue" />
          </LaddaButton>
          <span className="font-weight-bold text-center">
            Dont know?
            <NavLink
              href={`mailto:${process.env.CONTACT_EMAIL || 'manuel@securitize.io'}`}
              className="ml-1 p-0 d-inline-block"
            >
              Contact us by email
            </NavLink>
          </span>
        </ModalFooter>
        {
          isError && (
            <div className="mt-2 mb-0 form-group">
              <Alert color="danger mb-0 text-center">
                {errorType}
              </Alert>
            </div>
          )
        }
      </form>
    </ModalComponent>
  );
};

TwoFactorAuthModal.defaultProps = {
  isError: false,
  errorType: '',
};

TwoFactorAuthModal.propTypes = {
  onToggle: PropTypes.func.isRequired,
  loginUser: PropTypes.func.isRequired,
  getTranslations: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  options: PropTypes.objectOf(PropTypes.any).isRequired,
  isError: PropTypes.bool,
  errorType: PropTypes.string,
};

const mapStateToProps = ({ helpers: { modal, options } }) => ({
  options,
  isError: modal.isError,
  loading: modal.loading,
  errorType: modal.errorType,
});

export default connect(
  mapStateToProps,
  {
    loginUser,
    getTranslations,
  },
)(TwoFactorAuthModal);
